import React, { useContext, useState } from "react";
import { FileUploaderButton } from "../../../Components/FileUploaderButton";

import { v4 as uuidv4 } from "uuid";
import { NotificationContext } from "../../../Context/NotificationContext";
import { storage } from "../../../firebase.config";
import { BankPaymentDetails } from "../../../utility/enums";

const CheckTransfer = ({ windowSize, files, setFiles }) => {

  const { showNotification } = useContext(NotificationContext);

  const handleFiles = async (e) => {
    const mFiles = Array.from(e.target.files);

    if (!mFiles.length) return;

    const oID = uuidv4();
    const storageRef = storage.ref();

    for (let file of mFiles) {
      const fileID = uuidv4();
      const subFolder = uuidv4();
      const fileRef = storageRef.child(`${oID}/${subFolder}/${file.name}`);

      const downloadToken = uuidv4();
      const encodedFileName = encodeURIComponent(file.name);

      const fileUrl = `${process.env.REACT_APP_STORAGE_URL}/o/${oID}%2F${subFolder}%2F${encodedFileName}?alt=media&token=${downloadToken}`;

      const metadata = {
        firebaseStorageDownloadTokens: downloadToken,
        customMetadata: { orderID: oID },
      };

      // Add file to state
      setFiles((prevFiles) => [
        ...prevFiles,
        {
          id: fileID,
          name: file.name,
          progress: 0,
          status: "uploading",
          ref: `${oID}/${subFolder}/${file.name}`,
        },
      ]);

      const uploadTask = fileRef.put(file, metadata);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = (
            (snapshot.bytesTransferred / snapshot.totalBytes) *
            100
          ).toFixed(2);
          setFiles((prevFiles) =>
            prevFiles.map((f) => (f.id === fileID ? { ...f, progress } : f))
          );
        },
        (error) => {
          // setFiles((prevFiles) =>
          //   prevFiles.map((f) =>
          //     f.id === fileID ? { ...f, status: "failed" } : f
          //   )
          // );
          setFiles((prevFiles) =>
            prevFiles.filter((f) => f.id !== fileID)
          );
          showNotification(
            "Error uploading",
            `Failed to upload ${file.name}. Please try again.`,
            "error"
          );
        },
        () => {
          setFiles((prevFiles) =>
            prevFiles.map((f) =>
              f.id === fileID
                ? {
                    ...f,
                    status: "complete",
                    url: fileUrl,
                    timestamp: Date.now(),
                  }
                : f
            )
          );
        }
      );
    }
  };

  const handleDeleteFile = (file) => {
    const checkFile = (file1, file2) => {
      if(file1.id && file2.id){
        return file1.id === file2.id;
      }
      if(file1.ref && file2.ref){
        return file1.ref === file2.ref;
      }
    }
    const storageRef = storage.ref();

    if (file.ref && (file.status === "complete" || file.timestamp)) {
      const fileRef = storageRef.child(file.ref);
      setFiles((f) =>
        f.map((mFile) =>
          mFile.name === file.name && checkFile(mFile, file)
            ? { ...mFile, status: "deleting" }
            : mFile
        )
      );

      fileRef
        .delete()
        .then(function () {
          setFiles((f) => f.filter((mFile) => !checkFile(mFile, file)));
        })
        .catch(function (error) {
          showNotification(
            "Error deleting the file.",
            "There was an error deleting the file " +
              file.name +
              ". Please, try again.",
            "error"
          );
        });
    } else if (file.status === "failed") {
      setFiles((f) => f.filter((mFile) => !checkFile(mFile, file)));
    } else {
      file.task.cancel();
      setFiles((f) => f.filter((mFile) => !checkFile(mFile, file)));
    }
  };

  return (
    <div className="w-full accountDetailsScroll h-[calc(100vh-258px)] px-5 pb-5 space-y-4"> 
      <h3 className="text-[#030F23] font-secondary font-semibold  ">
        How to pay by check
      </h3>

      <ol className="list-decimal list-inside space-y-2 text-[#030F23] font-primary text-base">
        <li>Use Payment Details below to pay us by check.</li>
        <li>
          On the back of the check, please write: <br />
          <strong className="px-4">
            "Alejo Fiasche Cormick. For mobile deposit at Mercury only".
          </strong>
        </li>
        <li>
          Upload the front and back of your check. Ensure the photo clearly
          shows all four corners of the check.
        </li>
      </ol>

      <h3 className="text-[#030F23] font-secondary font-semibold ">
        Payment Details
      </h3>

      <div className="grid grid-cols-1 w-full gap-3 ">
        {BankPaymentDetails.map((item, index) => (
          <>
            <div className="flex items-center gap-4" key={index}>
              <p className=" text-[#686F7B] w-1/4 ">{item.title}</p>
              <p className=" text-[#030F23] ">{item.value}</p>
            </div>
            {index !== BankPaymentDetails.length - 1 && (
              <hr className="bg-[#F7F6F7] w-full" />
            )}
          </>
        ))}
      </div>

      <h3 className="text-[#030F23] font-secondary font-semibold  ">
        Proof of Payment
      </h3>

      <p className="text-[#686F7B] ">
        Attach a photo or screenshot of the payment receipt
      </p>

      <FileUploaderButton
        display
        text="Choose Files"
        files={files}
        handleFiles={handleFiles}
        handleDeleteFile={handleDeleteFile}
        hideDate={true}
        hideAddComment={true}
        fontSize={
          windowSize.width > 1024
            ? 1.1
            : windowSize.width > 767
            ? windowSize.orientation === "portrait"
              ? 1.6
              : 1.1
            : windowSize.orientation === "portrait"
            ? 5
            : 1.5
        }
      />
    </div>
  );
};

export default CheckTransfer;
